/**
* @Author: wangkai
* @Date: 2018/9/30
* @Last Modified by: wangkai
* @Desc: axios实例简单封装
**/

import axios from 'axios';
import qs from 'qs';
import { server_api } from '@/config/server_api';
import { getToken, delRepeatHttpRequest } from './tools'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import Vue from 'vue';

Vue.use(LoadingPlugin);
import { is_weixn } from '../utils';
const { localURL, baseURL, mockURL, microServiceURL } = server_api();
const app_device = is_weixn() ? 2 : 1;
const instance = axios.create({

baseURL: localURL || baseURL || mockURL,
timeout: 60000,
withCredentials: false, // 表示跨域请求时是否需要使用凭证
headers: {
'Content-Type': 'application/x-www-form-urlencoded',
'app_device': app_device,
'push_userid': '0',
'plat_form': '0',
'device_number': '0' //获取设备号
}
});
const CancelToken = axios.CancelToken;
const requestMap = new Map();
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
instance.interceptors.request.use(
config => {
if (config.isMicroService) {
config.baseURL = microServiceURL;
delete config.isMicroService
}

Vue.$vux.loading.show({ text: 'Loading' });
const { method, data, header } = config;

delRepeatHttpRequest(requestMap, config, qs, CancelToken);






if (header) {
config.headers = {
...config.headers,
...header
}
}
if (method === 'post' && config.headers['Content-Type'].indexOf('json') === -1) {
config.data = qs.stringify(data);
}


const token = getToken();
token && (config.headers['user_token'] = token);
return config;
},
error => {
console.error('request error');
return Promise.reject(error);
}
);
instance.interceptors.response.use(
res => {

Vue.$vux.loading.hide();
requestMap.set(res.config._keyString, false);
const { status, data } = res;
if (status === 200) {

if (data.code !== 0) return Promise.reject(data);
return data;
}
console.error('response status error');

return Promise.reject(res);
},
error => {
console.error('response error');
return Promise.reject(error);
}
);
export default instance;



// WEBPACK FOOTER //
// ./src/request/axiosConfig.js